import { useEffect } from "react"
import { useAppState } from "../../context/appStateContext"
import { PurchasProvider } from "../../context/purchaseContext"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import AlternativeBottomPaywall from "../AlternativeBottomPaywall/AlternativeBottomPaywall"
import {
  NavigationController,
  useNavigation,
} from "../../components/NavigationController/NavigationController"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import styles from "./TAPaywall.module.scss"
import TAPromoPaywall from "./TAPromoPaywall/TAPromoPaywall"
import PushedScreen from "../../components/PushedScreen/PushedScreen"
import { PromoProvider } from "../../context/promoContext"
import native from "../../native/native"

const TAPaywall = () => {
  const { state, actions } = useAppState()

  useEffect(() => {
    actions.setFooterInsetColor("var(--background)")
    actions.setHeaderInsetColor("var(--background)")
  }, [])

  if (!state.fullyLoaded) {
    return <div>Loading</div>
  }

  return (
    <PurchasProvider>
      <FullScreenPage containerClassName={styles.container}>
        <UltimateAlertsProvider>
          <PromoProvider>
            <NavigationController
              screens={[<PaywallContent />, <TAPromoPaywall rightAlignClose />]}
            />
            <div
              aria-hidden
              style={{
                position: "absolute",
                width: 0,
                height: 0,
                overflow: "hidden",
              }}
            >
              <TAPromoPaywall />
            </div>
          </PromoProvider>
        </UltimateAlertsProvider>
      </FullScreenPage>
    </PurchasProvider>
  )
}

const PaywallContent = () => {
  const navigation = useNavigation()

  const showPromo = useAppState().state.purchaseCancelled

  useEffect(() => {
    if (showPromo) {
      native.logMixpanelEvent("html_ta_promo_shown")
    }
  }, [showPromo])

  return (
    <>
      {showPromo && <TAPromoPaywall slideIn />}
      <AlternativeBottomPaywall
        onClose={() => {
          if (!showPromo) {
            native.logMixpanelEvent("html_regular_promo_shown")
            navigation.push()
          }
        }}
      />
    </>
  )
}

export default TAPaywall
